import {observable, action} from 'mobx'
import {notification} from 'antd'

import {List} from 'Store/_shared/list'
import {Single} from './single'

export class StockFilter {
  @observable selectedRowKeys = []
  @observable loadingTickers = false
  @observable loadedFirstNRows = false

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
    this.list = new List(this.api, 'stock filter')
    this.single = new Single(rootStore, api)
  }

  @action async previewStocks() {
    const {conditions, custom_logic} = this.single.data
    const body = {
      conditions: conditions.filter(condition => condition.validate()).map(condition => condition.transform()),
      custom_logic
    }
    if (!conditions.length) {
      notification['warning']({
        message: 'Please add at least one condition'
      })
      return
    }
    this.loadingTickers = true
    try {
      const {data, loaded_first_n_rows} = await this.api.request('sys/stock-filters/preview-stocks', 'post', body)
      let tickers = []
      data.map(({ticker, data}) => {
        tickers.push({
          ticker: {...ticker},
          data: {
            '0': false,
            ...data
          }
        })
      })
      this.loadedFirstNRows = loaded_first_n_rows
      this.single.change('selected_tickers', {tickers})
    } catch (e) {
      notification['error']({
        message: 'Failed to preview stocks',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.loadingTickers = false
      this.single.changed = true
    }
  }
}
